
    $(document).ready(function() {

        function limpa_formulário_cep() {
            // Limpa valores do formulário de cep.
            $("#ep_rua").val("");
            $("#ep_bairro").val("");
        }

        //Quando o campo cep perde o foco.
        $("#ep_cep").blur(function() {

            //Nova variável "cep" somente com dígitos.
            var cep = $(this).val().replace(/\D/g, '');

            //Verifica se campo cep possui valor informado.
            if (cep != "") {

                //Expressão regular para validar o CEP.
                var validacep = /^[0-9]{8}$/;

                //Valida o formato do CEP.
                if(validacep.test(cep)) {

                    //Preenche os campos com "..." enquanto consulta webservice.
                    $("#ep_rua").val("...");
                    $("#ep_bairro").val("...");

                    //Consulta o webservice viacep.com.br/
                    $.getJSON("https://viacep.com.br/ws/"+ cep +"/json/?callback=?", function(dados) {

                        if (!("erro" in dados)) {
                            //Atualiza os campos com os valores da consulta.
                            $("#ep_rua").val(dados.logradouro);
                            $("#ep_bairro").val(dados.bairro);
                            //alert(dados.ibge);

                            $.ajax({
                                dataType: 'json',
                                url: '/ajax/get-cidade-ibge',
                                data: {q: dados.ibge},
                                success: function (data) {
                                    var label = data.name + ' - ' + data.uf.sigla;
                                    var key = '{"ep_cidade_id":"' + data.id + '","ep_uf_id":"' + data.uf_id + '"}';
                                    var newOption = new Option(label, key, true, true);
                                    $('#ep_cidade_id').append(newOption).trigger('change');
                                    $('#ep_numero').focus();
                                }
                            });

                        } //end if.
                        else {
                            //CEP pesquisado não foi encontrado.
                            limpa_formulário_cep();
                            alert("CEP não encontrado.");
                        }
                    });
                } //end if.
                else {
                    //cep é inválido.
                    limpa_formulário_cep();
                    alert("Formato de CEP inválido.");
                }
            } //end if.
            else {
                //cep sem valor, limpa formulário.
                limpa_formulário_cep();
            }
        });

        /* Cep Correspondência */

        function ec_limpa_formulário_cep() {
            // Limpa valores do formulário de cep.
            $("#ec_rua").val("");
            $("#ec_bairro").val("");
        }

        //Quando o campo cep perde o foco.
        $("#ec_cep").blur(function() {

            //Nova variável "cep" somente com dígitos.
            var cep = $(this).val().replace(/\D/g, '');

            //Verifica se campo cep possui valor informado.
            if (cep != "") {

                //Expressão regular para validar o CEP.
                var validacep = /^[0-9]{8}$/;

                //Valida o formato do CEP.
                if(validacep.test(cep)) {

                    //Preenche os campos com "..." enquanto consulta webservice.
                    $("#ec_rua").val("...");
                    $("#ec_bairro").val("...");

                    //Consulta o webservice viacep.com.br/
                    $.getJSON("https://viacep.com.br/ws/"+ cep +"/json/?callback=?", function(dados) {

                        if (!("erro" in dados)) {
                            //Atualiza os campos com os valores da consulta.
                            $("#ec_rua").val(dados.logradouro);
                            $("#ec_bairro").val(dados.bairro);
                            //alert(dados.ibge);

                            $.ajax({
                                dataType: 'json',
                                url: '/search-ibge-ajax',
                                data: {q: dados.ibge},
                                success: function (data) {
                                    var label = data.nome + ' - ' + data.uf.sigla;
                                    var key = '{"ec_cidade_id":"' + data.id + '","ec_uf_id":"' + data.uf_id + '"}';
                                    var newOption = new Option(label, key, true, true);
                                    $('#ec_cidade_id').append(newOption).trigger('change');
                                    $('#ec_numero').focus();
                                }
                            });

                        } //end if.
                        else {
                            //CEP pesquisado não foi encontrado.
                            ec_limpa_formulário_cep();
                            alert("CEP não encontrado.");
                        }
                    });
                } //end if.
                else {
                    //cep é inválido.
                    ec_limpa_formulário_cep();
                    alert("Formato de CEP inválido.");
                }
            } //end if.
            else {
                //cep sem valor, limpa formulário.
                ec_limpa_formulário_cep();
            }
        });
    });